var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-tooltip",
        {
          attrs: {
            disabled: !_vm.info.serverGroupId,
            effect: "dark",
            content: _vm.$t(
              "pc_kng_courseware_lbl_cache_not_allowed" /*为保证资源安全，私有云课件不允许学员缓存哦～*/
            ),
            placement: "bottom-start",
          },
        },
        [
          _c(
            "yxt-checkbox",
            {
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.disabled,
              },
              model: {
                value: _vm.allowDownload_,
                callback: function ($$v) {
                  _vm.allowDownload_ = $$v
                },
                expression: "allowDownload_",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_kng_lbl_allow_cache" /** 允许缓存 */)) +
                  " \n      "
              ),
              _vm.allowDownload_
                ? _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "pc_kng_msg_view_without_traffic" /**（缓存后，学员在App内无需流量即可查看，但不能分享、转发）*/
                          )
                        ) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _vm.allowDownload_
        ? _c(
            "div",
            [
              _c(
                "yxt-radio-group",
                {
                  staticClass: "ml24",
                  attrs: { direction: "row", disabled: _vm.disabled },
                  model: {
                    value: _vm.permissionType,
                    callback: function ($$v) {
                      _vm.permissionType = $$v
                    },
                    expression: "permissionType",
                  },
                },
                [
                  _c("yxt-radio", { attrs: { label: 0 } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pc_kng_lbl_classification_app_cache" /** 跟随分类中的“App缓存课件”权限 */
                        )
                      )
                    ),
                  ]),
                  _c("yxt-radio", { attrs: { label: 1 } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pc_kng_upload_lbl_cache_allow" /** 单独设置允许缓存 */
                        )
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm.permissionType === 1
                ? _c("auth-selector", {
                    staticClass: "mt10 ml24",
                    attrs: {
                      permissions: _vm.permissions,
                      disabled: _vm.disabled,
                      dataPermissionCode:
                        "kjgl_Courseware_cache_selection_range",
                    },
                    on: { update: _vm.update },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }